import * as React from 'react';
import { Col, Row } from 'reactstrap';
import './Title.css';

export interface ITitleProps {
    title: string;
}
 
const Title: React.SFC<ITitleProps> = (props) => {
    return ( <Row>
        <Col xs="12">
            <div className="topic-title">
                <span className="title-text">{props.title}</span>
            </div>
        </Col>
    </Row> );
}
 
export default Title;


// WEBPACK FOOTER //
// ./src/components/title/Title.tsx